<div class="container">
  <div class="row align-items-center">
    <div class="col">
      © {{year}} Winchester Consulting Ltd
    </div>
    <div class="col-auto">
      <ul class="footer-nav">
        <li><a href="/static/docs/Terms_and_Conditions.pdf" title="PDF" target="_blank" class="underlined">Terms & Conditions</a></li>
        <li><a href="/static/docs/Privacy_and_Data_Protection.pdf" title="PDF" target="_blank" class="underlined">Privacy & Data Policy</a></li>
        <li><a [routerLink]="['/contact-us' | routeTenant]" class="underlined">Contact us</a></li>
      </ul>
    </div>
  </div>
</div>
